import dayjs from "./dayjs";

const formatDate = (date: string) => {
  const d = dayjs(date);
  return `${d.format("dddd, MMM Do")} at ${d.format("h:mma")}`;
};

const formatShortDate = (date: string) => {
  const d = dayjs(date);
  return d.format("dddd, MMM Do");
};

const formatHour = (date: string) => {
  const d = dayjs(date);
  return d.format("h:mma");
}

export { formatDate, formatShortDate, formatHour };
